import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'
import VUserCgu from './VUserCgu.vue'

registerVueComponentAndAngularBindings('vuser:cgu', 'vuserCgu', VUserCgu)
